import { render, staticRenderFns } from "./AppInit.vue?vue&type=template&id=c5a32306&scoped=true"
import script from "./AppInit.vue?vue&type=script&lang=js"
export * from "./AppInit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a32306",
  null
  
)

export default component.exports